import { useTheme } from "@mui/material";
import { Button, FoodsTooltip, Typography } from "@foodpilot/foods";

type AuditLogFilterLinkProps = {
    label: string;
    tooltip: string;
    onClick: () => void;
};

/**
 * A value that carries its own filter. The tooltip states what the click will do, because a
 * piece of text that turns into a filter is not something a reader expects to be clickable.
 */
export const AuditLogFilterLink = (props: AuditLogFilterLinkProps) => {
    const { label, tooltip, onClick } = props;
    const theme = useTheme();

    return (
        <FoodsTooltip title={tooltip}>
            <Button
                variant="text"
                onClick={onClick}
                sx={{
                    alignSelf: "flex-start",
                    borderRadius: theme.spacing(0.5),
                    paddingX: theme.spacing(0.5),
                    marginLeft: theme.spacing(-0.5),
                    textAlign: "left",
                    "&:hover": { backgroundColor: theme.palette.grey[100] },
                }}
            >
                <Typography variant="body-semibold" sx={{ wordBreak: "break-all" }}>
                    {label}
                </Typography>
            </Button>
        </FoodsTooltip>
    );
};
